
<template>
    <v-layout column>
        <v-card class="pa-2 mb-4 primary" v-if="national">
            <v-layout justify-space-between class="py-1 ml-2">
                <v-flex xs11 class="mr-3">
                    <gmap-autocomplete
                        id="autocomplete"
                        class="pl-2 mr-5 mt-1 py-2 white"
                        style="color: black; min-width: 100%"
                        placeholder="Find closest facility by city, state, or zip code..."
                        @place_changed="setPlace($event)"
                    />
                </v-flex>
                <v-flex xs1 class="mr-4">
                    <v-btn
                        data-testid="pagination-reset-btn"
                        class="pagination-reset-btn py-1 mx-0 float-right"
                        :disabled="!location"
                        @click="reset"
                        :loading="loading"
                        color="error white--text"
                    >
                      Reset
                    </v-btn>
                </v-flex>
            </v-layout>
        </v-card>
        <v-data-table
            :headers="headers"
            :items="facilities"
            :options.sync="options"
            :server-items-length="totalFacilities"
            :footer-props="{'items-per-page-options': [ 10, 25, 50, 75, 100 ]}"
            :loading="loading"
            no-data-text="No facilities found."
            :hide-default-footer="!!location"
        >
        <template v-slot:[`item.location_code`]="{ item }">
        <td>{{ item.location_code }}</td>
      </template>
      <template v-slot:[`item.name`]="{ item }">
        <td>{{ item.name }}</td>
      </template>
      <template v-slot:[`item.distance`]="{ item }" v-if="location !== null">
        <td>
            <span v-if="item.distance">{{ item.distance.toFixed(2) }} mi.</span>
            <span v-else>N/A</span>
        </td>
      </template>
      <template v-slot:[`item.street_address`]="{ item }">
        <td>{{ item.street_address }}</td>
      </template>
      <template v-slot:[`item.city`]="{ item }">
        <td>{{ item.city }}</td>
      </template>
      <template v-slot:[`item.state`]="{ item }">
        <td>{{ item.state }}</td>
      </template>
      <template v-slot:[`item.postal_code`]="{ item }">
        <td>{{ item.postal_code }}</td>
      </template>
      <template v-slot:[`item.phone`]="{ item }">
        <td>{{ addDashes(item.phone) }}</td>
      </template>
      <template v-slot:[`item.actions`]="{ item }">
        <td>
                    <v-btn
                        v-if="national"
                        data-testid="pagination-select-facility-btn"
                        class="pagination-select-facility-btn"
                        small
                        color="primary"
                        @click="selectFacility(item)"
                    >
                      Select
                    </v-btn>
                    <v-btn
                        v-else
                        data-testid="pagination-edit-facility-btn"
                        class="pagination-edit-facility-btn"
                        :to="{ name: 'adminFacilityDetails', params: { facilityId: item.id } }"
                        small
                        color="primary"
                    >
                      Edit
                    </v-btn>
                </td>
      </template>
        </v-data-table>
    </v-layout>
</template>

<script>
import { facilityListDataTableHeaders } from "@/helpers/facilities/facility-list-data-table-headers";
import router from "@/router";

export default {
  props: ["type"],

  data() {
    return {
      facilityListDataTableHeaders: facilityListDataTableHeaders,
      location: null,
      options: {}
    };
  },

  methods: {
    getFacilities() {
      this.location = null;
      this.$store.dispatch("getFacilityList", this.options);
    },

    selectFacility(facility) {
      this.$store.dispatch("handleResetTenant");
      localStorage.setItem("locationCode", facility.location_code);
      router.push({
        name: "facilityDetails",
        params: { facilityId: facility.id }
      }).catch(() => {});
    },

    setPlace(location) {
      this.location = location.formatted_address;
      this.$store.dispatch("getFacilityByLocation", this.location)
        .catch(() => {
          this.getFacilities();
        });
    },

    addDashes(phone) {
      if (phone) {
        if (phone.length === 10 && typeof phone.replace === "function") {
          return phone.replace(/(\d{3})(\d{3})(\d{4})/, "$1-$2-$3");
        } else {
          return phone;
        }
      }
    },

    reset() {
      this.getFacilities();
      document.getElementById("autocomplete").innerText = "";
      this.location = null;
    }
  },

  computed: {
    headers() {
      if (!this.location) {
        return this.facilityListDataTableHeaders.filter(
          (h) => h.value !== "distance"
        );
      }
      return this.facilityListDataTableHeaders;
    },
    loading() {
      return this.$store.getters.isLoading("Loading Facilities");
    },
    national() {
      return this.type === "national";
    },
    facilities: {
      get() {
        return this.$store.getters.facilityList;
      },
      set(value) {
        this.$store.commit("setFacilityList", value);
      }
    },
    totalFacilities: {
      get() {
        return this.$store.getters.facilityListPagination.total;
      },
      set(value) {
        this.$store.commit("setFacilityListPagination", value);
      }
    }
  },

  watch: {
    options: {
      handler() {
        this.getFacilities();
      },
      deep: true
    }
  }
};
</script>

<style scoped>
    #autocomplete {
        background: #3B3B3B;
        outline: none;
        border-bottom: 1px #C7C7C7 solid;
    };
</style>
